import { render, staticRenderFns } from "./ProductMain.vue?vue&type=template&id=1207d91c"
import script from "./ProductMain.vue?vue&type=script&lang=js"
export * from "./ProductMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports